import LeadInfoIcon from 'assets/LeadInfo/user.svg';
import Competition from 'assets/salesNew/competition.svg';
import TeamIcon from 'assets/salesNew/competitor/team.png';
import UcomIcon from 'assets/salesNew/competitor/ucom.png';
import VivaIcon from 'assets/salesNew/competitor/viva.png';
import Offer from 'assets/salesNew/offer.svg';
import Product from 'assets/salesNew/product.svg';
import HomeIcon from 'assets/salesNew/product/home.svg';
import IntercomIcon from 'assets/salesNew/product/intercom.svg';
import InternetIcon from 'assets/salesNew/product/internet.svg';
import TVIcon from 'assets/salesNew/product/tv.svg';
import Source from 'assets/salesNew/source.svg';
import B2BIcon from 'assets/salesNew/source/b2b.svg';
import B2CIcon from 'assets/salesNew/source/b2c.svg';
import CoworkerIcon from 'assets/salesNew/source/coworker.png';
import D2DIcon from 'assets/salesNew/source/d2d.png';
import FacebookIcon from 'assets/salesNew/source/fb.svg';
import InstaIcon from 'assets/salesNew/source/insta.svg';
import InIcon from 'assets/salesNew/source/linkedin.svg';
import NeighborIcon from 'assets/salesNew/source/neighbor.png';
import TikTokIcon from 'assets/salesNew/source/tiktok.svg';

export const HEADER_STEPS = [
  { title: 'Lead Info', sub: 'Create Lead', icon: LeadInfoIcon },
  { title: 'Source', sub: 'Select Source', icon: Source },
  { title: 'Product', sub: 'Select Product', icon: Product },
  { title: 'Offers', sub: 'Select Offer', icon: Offer },
  { title: 'Competitor', sub: 'Select Competitor', icon: Competition },
];
export const COUNTRIES = ['Armenia', 'Georgia', 'USA', 'Germany', 'France', 'Russia'];
export const REGIONS = ['Yerevan', 'Gyumri', 'Vanadzor', 'Ararat', 'Armavir', 'Lori'];
export const CITIES = ['Yerevan', 'Gyumri', 'Vanadzor'];
export const DISTRICTS = ['Hrachya Qochar', 'Komitas', 'Center'];
export const STREETS = ['Tumanyan', 'Sayat-Nova', 'Abovyan', 'Arami', 'Pushkin'];

export const BUILDINGS = ['23', '45/1', '12', '8', '105'];

export const STATUS_OPTION = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'seen', label: 'Seen' },
];
export const SOURCES = [
  { id: 'Facebook', title: 'Facebook', icon: FacebookIcon, className: 'fbIcon' },
  { id: 'Instagram', title: 'Instagram', icon: InstaIcon, className: 'instaIcon' },
  { id: 'Coworker', title: 'Coworker', icon: CoworkerIcon, className: 'coworkerIcon' },
  { id: 'B2B', title: 'B2B', icon: B2BIcon, className: 'b2bIcon' },
  { id: 'Linkedin', title: 'Linkedin', icon: InIcon, className: 'inIcon' },
  { id: 'D2D', title: 'D2D', icon: D2DIcon, className: 'd2dIcon' },
  { id: 'B2C', title: 'B2C', icon: B2CIcon, className: 'b2cIcon' },
  { id: 'Neighbor', title: 'Neighbor', icon: NeighborIcon, className: 'neighborIcon' },
  { id: 'TikTok', title: 'TikTok', icon: TikTokIcon, className: 'tiktokIcon' },
];
export const PRODUCTS = [
  {
    id: 'TV',
    title: 'TV',
    subText: 'Premium Service',
    icon: TVIcon,
    mainColor: '#A855F7',
    bgColor: '#F5F3FF',
  },
  {
    id: 'Internet',
    title: 'Internet',
    subText: 'Premium Service',
    icon: InternetIcon,
    mainColor: '#3B82F6',
    bgColor: '#EFF6FF',
  },
  {
    id: 'Intercom',
    title: 'Intercom',
    subText: 'Premium Service',
    icon: IntercomIcon,
    mainColor: '#10B981',
    bgColor: '#ECFDF5',
    isSmall: true,
  },
  {
    id: 'Home',
    title: 'All in One',
    subText: 'Premium Service',
    icon: HomeIcon,
    mainColor: '#F59E0B',
    bgColor: '#FFFBEB',
  },
];
export const OFFERS = Array(10)
  .fill({
    id: Math.random(),
    title: 'Smart Intercom',
    price: '200',
    currency: 'AMD',
    units: '11 Units Included',
    validity: 'Valid: 20/09/2025 - 30/09/2025',
    footer: 'Premium Offer',
  })
  .map((item, index) => ({ ...item, id: index }));

export const COMPETITORS = [
  { id: 'viva', name: 'Viva Cell', type: 'Competitor', logo: VivaIcon },
  { id: 'ucom', name: 'Ucom', type: 'Competitor', logo: UcomIcon },
  { id: 'team', name: 'Team', type: 'Competitor', logo: TeamIcon },
];
export const BIG_OFFERS = [
  { id: 'big-1', title: 'Smart Intercom', price: '200' },
  { id: 'big-2', title: 'Smart Intercom', price: '200' },
];
export const CONTACT_INFO_DEFAULT_VALUES = {
  firstName: '',
  lastName: '',
  patronymic: '',
  phone: { value: '' },
  status: null,
};
export const CONTACT_INFO_B2B_DEFAULT_VALUES = {
  companyName: '',
  description: '',
  webAdress: '',
  numberOfEmployees: '',
  phone: { value: '' },
  status: null,
};
